import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

function SttServiceProvidersTable({ providers, onEdit, onDelete }) {
    return (
        <table className="app-table">
            <thead>
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Edit</th>
                <th>Delete</th>
            </tr>
            </thead>
            <tbody>
            {providers.map(provider => (
                <ProviderRow provider={provider} key={provider.id} onEdit={onEdit} onDelete={onDelete} />
            ))}
            </tbody>
        </table>
    );
}

function ProviderRow({ provider, onEdit, onDelete }) {
    return (
        <tr>
            <td>{provider.id}</td>
            <td>{provider.name}</td>
            <td>
                <FaEdit className="edit-icon" onClick={() => onEdit(provider)} />
            </td>
            <td>
                <FaTrash className="delete-icon" onClick={() => onDelete(provider.id)} />
            </td>
        </tr>
    );
}

export default SttServiceProvidersTable;
